export default __webpack_public_path__ + "static/media/twitter.112d9310.png";